/**
 * The flat `action:subject` key a grant lives under, everywhere one is keyed: the role editor's
 * form fields, the user grid's checkbox maps, and the payloads both write. One producer, so the
 * two grids and the server-bound records cannot drift on how a pair is spelled.
 *
 * @param action - The manifest action.
 * @param subject - The manifest subject.
 * @returns The `action:subject` key.
 */
export function grantKey(action: string, subject: string): string {
	return `${action}:${subject}`;
}
